import ColumnsStorage from '../../../../common/ColumnsStorage';
import { dynamicColumns } from '../columns';

const key = 'advertisement-keyword-planner';

export default new ColumnsStorage({
  keyToStoreWith: key,
  columns: dynamicColumns,
});
